const General = () => {
  return <h1 className="text-lg font-bold text-gray-600 mb-1">General</h1>;
};

export default General;
